import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import {
  addTelnetAction,
  getActivationToggleAction,
  getAllTelnetAction,
  getCheckUniqueCompanyNameAction,
  getCheckUniqueEmailAction,
  getCheckUniqueVatAction,
  getDeleteTelnetAction,
  getResetPasswordAction,
  getSingleTelnetAction,
  getSuspensionToggleAction,
  getTelnetActivityAction,
  setActivationToggleAction,
  setAddTelnetAction,
  setActivationToggleErrorAction,
  setAllTelnetAction,
  setCheckUniqueCompanyNameAction,
  setCheckUniqueEmailAction,
  setCheckUniqueVatAction,
  setDeleteTelnetAction,
  setResetPasswordAction,
  setSingleTelnetAction,
  setSuspensionToggleAction,
  setTelnetActivityAction,
  updateTelnetAction,
  updateTelnetSubscriptionAction,
  setDeleteTelnetSuccessAction,
  setResetPasswordSuccessAction,
  setAddTelnetIdAction,
  setSuspensionToggleErrorAction,
  setClientForEditAction,
  getClientForEditAction,
  putEditClientAction,
  setEditClientAction,
  getPlanClientAction,
  setPlanClientAction,
  setAdminSuccessAction,
  setAdminErrorAction,
} from "../reducers/adminClientsSlice";
import { setLoaderAction, setNotificationAction, setToastAction } from "../reducers/mmymSlice";
import moment from "moment";
import { getUserProfile } from "../reducers/userSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */
function* getAllTelnetsSaga(action: { type: string; payload: { page: number; limit: number; orderBy: string; orderIn: string } }): any {
  const { page, limit, orderBy, orderIn } = action.payload;
  yield put(setLoaderAction(true));
 
  try {
    const clients = yield call<any>(
      callAPI,
      action.payload,
      "get",
      `tenants/list-clients?page=${page}&limit=${limit}&orderBy=${orderBy}&orderIn=${orderIn}`
    );
    
    if (clients?.data) {
      yield put(setAllTelnetAction(clients?.data));
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getSingleTelnetsSaga(action: any): any {
  yield put(setLoaderAction(true));
  try {
   
    const tenantId = action.payload; // Directly access the payload
    const singleClient = yield call<any>(
      callAPI,
      {},
      "get",
      `tenants/single?tenantId=${tenantId}`
    );
   
    if (singleClient?.data) {
      yield put(setSingleTelnetAction(singleClient?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getActivationToggleSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "put",
      `tenants/toggle-activation`
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setActivationToggleAction(true));
      yield put(setActivationToggleErrorAction(false));
    }
  } catch (error: any) {
    
    if (error?.response) {
      let errorData = error.response.data;
      // Move message to details if it exists
      if (errorData?.message) {
        errorData.details = Array.isArray(errorData.details)
          ? errorData.details
          : [];
        errorData.details.push(errorData.message);
        delete errorData.message; // Remove the message property
        yield put(setActivationToggleErrorAction(true));
      }
      handleError(errorData);
      error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setActivationToggleAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getResetPasswordSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const tenantId = action.payload?.tenantId; // Directly access the payload
   
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `tenants/reset-password?tenantId=${tenantId}`
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setResetPasswordAction(false));
      yield put(setResetPasswordSuccessAction(true));
    }
  } catch (error: any) {

    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setResetPasswordAction(true));
    
    yield put(setResetPasswordSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getSuspensionToggleSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "put",
      `tenants/toggle-suspension`
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setSuspensionToggleAction(true));
      yield put(setSuspensionToggleErrorAction(false));
    } 
  } catch (error: any) {
    
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setSuspensionToggleErrorAction(true));
    yield put(setSuspensionToggleAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getDeleteTelnetSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const tenantId = action.payload?.tenantId; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `tenants/delete-client?tenantId=${tenantId}`
    );

    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteTelnetAction(false));
      yield put(setDeleteTelnetSuccessAction(true));
      yield put(setSingleTelnetAction(null));
      
    }
  } catch (error: any) {
   
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteTelnetAction(true));

    yield put(setDeleteTelnetSuccessAction(false));
  }
  yield put(setLoaderAction(false));
}

function* updateTelnetSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "put",
      `admin/profile`
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAdminSuccessAction(true));
      yield put(setAdminErrorAction(false));
      yield put(getUserProfile())
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAdminSuccessAction(false));
    yield put(setAdminErrorAction(true));
  }
  yield put(setLoaderAction(false));
}

function removeBlankAttributes(obj: any) {
  const result: any = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== "") {
      if (
        key === "vatPercent" ||
        // key === "vatRegNo" ||
        key === "extendedLiabilityPercent" ||
        key === "extendedLiabilityTax" ||
        key === "insuranceFixedRate" ||
        key === "subscriptionCost" ||
        key === "discount" ||
        key === "amountPayable" ||
        key === "depositPaymentPercent" ||
        key === "invoiceDueDays"
      ) {
        // if (/^\d*$/.test(obj[key])) {
        if(/^\d+(\.\d{0,2})?$/.test(obj[key])) {
          // result[key] = parseInt(obj[key], 10); // Parse to integer
          result[key] = Number(obj[key]);
        } else {
          result[key] = obj[key];
        }
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

function* addTelnetSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const addClientObj = {
      role: payload?.payload?.role,
      companyProfile: removeBlankAttributes(payload?.payload?.companyProfile),
      financialInformation: removeBlankAttributes(
        payload?.payload?.financialInformation
      ),
      emailSetting: removeBlankAttributes(payload?.payload?.emailSetting),
    };
    const planObj = removeBlankAttributes(payload?.payload?.subscription);
    if(planObj?.startDate && planObj?.endDate){
      planObj.term = `${moment(planObj?.startDate).format("MM/DD/YYYY")} - ${planObj?.endDate}`
    }
    if(planObj?.planId){
      if(!planObj?.status){
        planObj.status = 'active'
      }
    }
    if(!payload?.payload?.tenantId){
    const apiResponse = yield call<any>(
      callAPI,
      {
        payload: addClientObj,
      },
      "post",
      `tenants/add-client`
    );
   
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      apiResponse && handleSuccess(apiResponse);
      const { tenantId } = apiResponse.data;
      yield put(setAddTelnetIdAction(tenantId))
      if (Object.keys(planObj).length > 0) {
        const subscriptionPayload = {
          tenantId,
          ...planObj,
        };
        yield put(updateTelnetSubscriptionAction(subscriptionPayload));
      } else {
        yield put(setAddTelnetAction(true));
        apiResponse && handleSuccess(apiResponse)
        yield put(getAllTelnetAction({
          page: 1,
          limit: 10,
          orderBy: "created_at",
          orderIn: "DESC",
        }))
      }
    }
  } else {
    if (Object.keys(planObj).length > 0) {
      const subscriptionPayload = {
        ...{tenantId: payload?.payload?.tenantId},
        ...planObj,
      };
      yield put(updateTelnetSubscriptionAction(subscriptionPayload));
      } else {
        yield put(setToastAction({ message: 'Subscription plan havn\'t added yet. You can update it later.', appearance: 'info' }));
        yield put(setAddTelnetAction(true));
      }
    }
  } catch (error: any) {
   
    error?.response && handleError(error?.response?.data)
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateTelnetSubscriptionSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `subscriptions/create`
    );
    
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddTelnetAction(true));
      apiResponse && handleSuccess(apiResponse)
      yield put(getAllTelnetAction({
        page: 1,
        limit: 10,
        orderBy: "created_at",
        orderIn: "DESC",
      }))
    }
  } catch (error: any) {
   
    // error?.response && handleError(error?.response?.data)
    error?.response && handleError(error?.response?.data);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getTelnetActivitySaga(action: any): any {
  try {
    const tenantId = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `tenants/audit-trails?tenantId=${tenantId}`
    );
    
    if (apiResponse?.success === true) {
      yield put(setTelnetActivityAction(apiResponse?.data?.list));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
}

function* getCheckUniqueEmailSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const email = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/exists?email=${email}`
    );
 
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setCheckUniqueEmailAction(false));
    }
  } catch (error: any) {

    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueEmailAction(true));
    
  }
  yield put(setLoaderAction(false));
}

function* getCheckUniqueCompanyNameSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const companyName = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/check-company-name?companyName=${companyName}`
    );
 
    if (apiResponse?.success === true) {
      yield put(setCheckUniqueCompanyNameAction(false));
      // yield put(setDeleteTelnetAction(apiResponse?.message));
    }
  } catch (error: any) {
 
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueCompanyNameAction(true));

  }
  yield put(setLoaderAction(false));
}

function* getCheckUniqueVatSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const vatRegNo = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/check-vat-reg-number?vatRegNo=${vatRegNo}`
    );
   
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setCheckUniqueVatAction(false));
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueVatAction(true));
 
  }
  yield put(setLoaderAction(false));
}

function* getClientForEditSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
 
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `client/tenant`
    );
  
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setClientForEditAction(apiResponse?.data));
    }
  } catch (error: any) {
   
    error?.response && handleError(error?.response)
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* putEditClientSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const addClientObj = {
      // tenantId: payload?.payload?.tenantId,
      companyProfile: removeBlankAttributes(payload?.payload?.companyProfile),
      financialInformation: removeBlankAttributes(
        payload?.payload?.financialInformation
      ),
      emailSetting: removeBlankAttributes(payload?.payload?.emailSetting),
    };
    const apiResponse = yield call<any>(
      callAPI,
      {
        payload: addClientObj,
      },
      "post",
      `client/tenant`
    );

    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setEditClientAction(true));
      apiResponse && handleSuccess(apiResponse);
    }
  } catch (error: any) {
    
    error?.response && handleError(error?.response)
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getPlanClientSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const tenantId = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `subscriptions/tenant?tenantId=${tenantId}`
    );
    
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setPlanClientAction(apiResponse?.data));
    }
  } catch (error: any) {
   
    error?.response && handleError(error?.response?.data)
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

export function* watchAdminClient() {
  yield takeLatest<any>(getAllTelnetAction, getAllTelnetsSaga);
  yield takeLatest<any>(getSingleTelnetAction, getSingleTelnetsSaga);
  yield takeLatest<any>(getActivationToggleAction, getActivationToggleSaga);
  yield takeLatest<any>(getResetPasswordAction, getResetPasswordSaga);
  yield takeLatest<any>(getSuspensionToggleAction, getSuspensionToggleSaga);
  yield takeLatest<any>(getDeleteTelnetAction, getDeleteTelnetSaga);
  yield takeLatest<any>(addTelnetAction, addTelnetSaga);
  yield takeLatest<any>(updateTelnetAction, updateTelnetSaga);
  yield takeLatest<any>(
    updateTelnetSubscriptionAction,
    updateTelnetSubscriptionSaga
  );
  yield takeLatest<any>(getTelnetActivityAction, getTelnetActivitySaga);
  yield takeLatest<any>(getCheckUniqueEmailAction, getCheckUniqueEmailSaga);
  yield takeLatest<any>(
    getCheckUniqueCompanyNameAction,
    getCheckUniqueCompanyNameSaga
  );
  yield takeLatest<any>(getCheckUniqueVatAction, getCheckUniqueVatSaga);
  yield takeLatest<any>(getClientForEditAction, getClientForEditSaga);
  yield takeLatest<any>(putEditClientAction, putEditClientSaga);
  yield takeLatest<any>(getPlanClientAction, getPlanClientSaga);
}
